import React from 'react'
import { Box } from 'native-base'
import { inject, observer } from 'mobx-react'
import { toJS } from 'mobx'
import LocalizationContext from '../../context/LocalizationContext'
import Loading from '../../components/basic/Loading'
import OrderList from '../../components/OrderList'
import _ from 'lodash'
import EmptyView from '../../components/basic/EmptyView'

function OrderListScreen(props) {
    const { t } = React.useContext(LocalizationContext)
    const { orderStore, navigation } = props
    const [isLoading, setIsLoading] = React.useState(true)
    const [search, setSearch] = React.useState(undefined)


    React.useEffect(() => {
        const componentDidMount = async () => {
            try {
                await orderStore.listOrders(search)
            }
            catch (e) {
                console.log(e)
            }
            setIsLoading(false)
        }

        componentDidMount()
    }, [navigation])

    React.useEffect(() => {
        const onSearchChange = async () => {
            try {
                await orderStore.listOrders(search)
            }
            catch (e) {
                console.log(e)
            }
        }
        onSearchChange()
    }, [search])

    const handleOnEndReached = async () => {
        if (toJS(orderStore.orders).length < toJS(orderStore.orderCount)) {
            try {
                await orderStore.listMoreOrders(toJS(orderStore.orders).length, search)
            }
            catch (e) {
                console.log(e)
            }
        }
    }

    if (isLoading) {
        return <Loading />
    }

    if (!toJS(orderStore.orders).length) {
        return <EmptyView t={t} />
    }

    return (
        <OrderList
            t={t}
            orders={toJS(orderStore.orders)}
            onEndReached={() => handleOnEndReached()}
            onChangeText={(value) => setSearch(value)}
            onOrderPress={(value) => { return navigation.push('OrderDetail', { orderId: value }) }}
        />
    )
}

export default inject('orderStore')(observer(OrderListScreen))